import { render, staticRenderFns } from "./marketingShop.vue?vue&type=template&id=c6b291be&scoped=true"
import script from "./marketingShop.vue?vue&type=script&lang=js"
export * from "./marketingShop.vue?vue&type=script&lang=js"
import style0 from "./marketingShop.vue?vue&type=style&index=0&id=c6b291be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b291be",
  null
  
)

export default component.exports